import { GetProfileMedicationsDtoStatusEnum } from 'woofwoof-api';
import { translateKey } from 'src/locales/translate';

type MedicationStatusInfo = {
  label: string;
  color:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';
  icon?: string;
};

/**
 * Shaped like `mapVisitStatusToString`, and drawing on the same icon set, so a
 * medication's status reads the way every other status in the dashboard does.
 */
export const mapMedicationStatusToString = (
  status?: GetProfileMedicationsDtoStatusEnum,
): MedicationStatusInfo | null => {
  if (!status) {
    return null;
  }

  const statusMap: Record<
    GetProfileMedicationsDtoStatusEnum,
    MedicationStatusInfo
  > = {
    SCHEDULED: {
      label: translateKey('medication.status.scheduled'),
      color: 'info',
      icon: 'solar:calendar-bold',
    },
    ACTIVE: {
      label: translateKey('medication.status.active'),
      color: 'success',
      icon: 'solar:check-circle-bold',
    },
    PAUSED: {
      label: translateKey('medication.status.paused'),
      color: 'warning',
      icon: 'solar:pause-circle-bold',
    },
    STOPPED: {
      label: translateKey('medication.status.stopped'),
      color: 'default',
      icon: 'solar:close-circle-bold',
    },
  };

  return statusMap[status] ?? null;
};
